import React, { useEffect, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { useLanguage } from '~/Hooks';
import { requestEventCategories, selectEventCategoryTypeList } from '~/store/events';
import { FilterCheckboxList } from '~/Components/Filter';
import { useSelectedMap } from '~/Hooks/useFilter/useSelectedMap';
import { FilterType } from '~/Hooks/useFilter';
import { useProviderFilters } from '~/Hooks/useFilter/useProviderFilters';

export interface IUseEventCategoriesGroupFilterProps {
  filterType: FilterType;
  initialFilter?: string[];
}

export const useEventCategoriesGroupFilter = ({
  filterType,
  initialFilter = [],
}: IUseEventCategoriesGroupFilterProps) => {
  const { appliedFilters } = useProviderFilters({ filterType });
  const { categoryTypes: initialState = initialFilter } = appliedFilters;

  const { t } = useLanguage();
  const dispatch = useDispatch();
  const getCategories = bindActionCreators(requestEventCategories, dispatch);
  const categoryIds = useSelector(selectEventCategoryTypeList);
  const list = useMemo(() => categoryIds.map((id) => ({ id, label: t(`event.category.${id}`) })), [
    t,
    categoryIds,
  ]);
  const {
    selectItem,
    onClearMap,
    onApplyMap,
    selectedMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  } = useSelectedMap({ initialState });

  useEffect(() => {
    if (!categoryIds.length) {
      getCategories();
    }
  }, []);

  return {
    name: 'categoryTypes',
    title: t('event.eventCategory'),
    elements: <FilterCheckboxList list={list} selectItem={selectItem} selectedMap={selectedMap} />,
    onClearMap,
    onApplyMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  };
};
